import { render } from "./EditUser.vue?vue&type=template&id=315bc8d2"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"
script.render = render

export default script